import React, { FC } from "react";
import { SessionProps } from "../../interfaces/session.interface";
import { FaCheck, FaTimes } from "react-icons/fa";

const SessionCard: FC<SessionProps> = ({
	time,
	heading,
	price,
	discountedPrice,
	colour,
	benefits,
	popularVariant = false,
}) => {
	const handleBookingClick = () => {
		// Use window.open to navigate to the URL
		window.open(
			"https://calendar.google.com/calendar/appointments/schedules/AcZssZ3Sqcc3WypNAiD7eKGFQMPzQ9O4oxk7PeJQ165k3NKi5E8sGqOAmjVTzFMutkfpsJX9Juxuby94?gv=true",
			"_blank"
		);
	};

	return (
		<div className="position-relative">
			<div
				className={`rounded-5 mb-4 ${
					popularVariant ? "popular-card-gradient shadow" : "bg-secondary"
				}`}
			>
				<div className={`p-3 p-md-4 p-xxl-5 ${popularVariant ? "card-content" : ""}`}>
					<div className="d-flex align-items-center mb-4">
						<div
							className="p-4 rounded-circle session-color-circle"
							style={{ '--session-color': colour } as React.CSSProperties}
						></div>
						<div className="ms-3">
							<small>{time} minutes</small>
							<h5 className="fw-medium">{heading}</h5>
						</div>
					</div>

					<div className="d-flex align-items-center mb-4">
						<div className="position-relative me-3">
							<h6 className={`fs-2 mb-2 fw-semibold mb-4 ${discountedPrice ? 'text-muted' : ''}`}>
								R{price}
							</h6>
							{discountedPrice && (
								<div className="strikethrough-line"></div>
							)}
						</div>
						{discountedPrice && (
							<h6 className="fs-2 mb-2 fw-semibold mb-4 fw-bold text-gradient">
								R{discountedPrice}
							</h6>
						)}
					</div>
					<ul className="list-unstyled">
						{benefits.map((benefit, index) => (
							<li key={index} className="mb-3 d-flex card-typography">
								<span className="d-block">
									{benefit.included ? (
										<FaCheck className="text-primary me-2" />
									) : (
										<FaTimes className="text-muted me-2" />
									)}
								</span>
								<span className={benefit.included ? "" : "text-muted"}>
									{benefit.benefit}
								</span>
							</li>
						))}
					</ul>
					<button
						onClick={handleBookingClick}
						className="w-100 btn btn-dark mt-4"
					>
						<p
							className="text-white my-1"
						>
							Book Session
						</p>
					</button>
				</div>
				{popularVariant && (
					<div className="text-center py-2">
						<small className="text-dark fw-bold">Limited time offer!</small>
					</div>
				)}
			</div>
		</div>
	);
};

export default SessionCard;
